import React, { ComponentType } from 'react'
import { 
  Grid, 
  Table 
} from 'semantic-ui-react'
// Local
import ComputerTable from './ComputerTable'
import If from './if'
import MaxTableFooter from './maxTableFooter'
import MoreTableFooter from './moreTableFooter'
import MobileRow from './mobileRow'

type MobileProps = {
  data: any
  more: any
  max: any
  onClick: any
  mobileColumns: any
  computerColumns: any
  onMore: any
}

type TableProps = {
  computerColumns: any
  mobileColumns: any
  data: any
  onClick: any
  more: any
  max: any
  onMore: any
  sortOnHeaderClick: any
}

const SafeTable = Table as unknown as ComponentType<any>
const SafeGrid = Grid as unknown as ComponentType<any>

function MobileTable(props: MobileProps) {
  const {
    data,
    more,
    max,
    onClick,
    mobileColumns,
    computerColumns,
    onMore
  } = props

  return (
    <SafeTable
      compact
      color="green"
      selectable
    >
      <Table.Body>
        { data.map((record: any) => (
          <MobileRow
            key={ record.id }
            record={ record }
            onClick={ onClick }
            mobileColumns={ mobileColumns }
          />
        )) }
      </Table.Body>
      <If isTrue={ more }>
        <MoreTableFooter
          columns={ computerColumns.length }
          onMore={ onMore }
        />
      </If>
      <If isTrue={ max !== undefined }>
        <MaxTableFooter
          columns={ computerColumns.length }
        />
      </If>
    </SafeTable>
  )
}

function TableComponent(props: TableProps) {
  const {
    computerColumns,
    mobileColumns,
    data,
    onClick,
    more,
    max,
    onMore,
    sortOnHeaderClick
  } = props
  return (
    <SafeGrid id="table">
      <Grid.Row
        columns={ 1 }
        only="computer tablet"
        className="left-padding"
      >
        <ComputerTable
          computerColumns={ computerColumns }
          data={ data }
          onClick={ onClick }
          more={ more }
          max={ max }
          onMore={ onMore }
          sortOnHeaderClick={ sortOnHeaderClick }
        />
      </Grid.Row>
      <Grid.Row
        columns={ 1 }
        only="mobile"
        className="left-padding"
      >
        <MobileTable
          computerColumns={ computerColumns }
          mobileColumns={ mobileColumns }
          data={ data }
          onClick={ onClick }
          more={ more }
          max={ max }
          onMore={ onMore }
        />
      </Grid.Row>
    </SafeGrid>
  )
}

export default TableComponent
